import type { RegisteredModule } from "./contracts";
export const generatedModules: RegisteredModule[] = [
  {
    moduleKey: "reporting",
    version: "3.0.0-alpha.1",
    enabled: true,
    routes: [
      {
        path: "/dashboard",
        label: "Dashboard",
        permission: "reporting.dashboards.read",
        load: () => import("@ips/module-reporting"),
      },
    ],
  },
  {
    moduleKey: "asset-registry",
    version: "3.0.0-alpha.1",
    enabled: true,
    routes: [
      {
        path: "/assets",
        label: "Anagrafica",
        permission: "assets.assets.read",
        load: () => import("@ips/module-asset-registry"),
      },
      {
        path: "/assets/types",
        label: "Tipologie asset",
        permission: "assets.types.read",
        navigation: "submenu",
        load: () => import("@ips/module-asset-registry"),
      },
    ],
  },
  {
    moduleKey: "documents",
    version: "3.0.0-alpha.1",
    enabled: true,
    routes: [
      {
        path: "/documents",
        label: "Documenti",
        permission: "documents.documents.read",
        load: () => import("@ips/module-documents"),
      },
      {
        path: "/documents/types",
        label: "Tipologie documento",
        permission: "documents.types.read",
        navigation: "submenu",
        load: () => import("@ips/module-documents"),
      },
    ],
  },
  {
    moduleKey: "maintenance",
    version: "3.0.0-alpha.1",
    enabled: true,
    routes: [
      {
        path: "/maintenance",
        label: "Manutenzioni",
        permission: "maintenance.plans.read",
        load: () => import("@ips/module-maintenance"),
      },
      {
        path: "/maintenance/report",
        label: "Invia segnalazione",
        permission: "maintenance.reports.create",
        navigation: "submenu",
        load: () => import("@ips/module-maintenance"),
      },
    ],
  },
  {
    moduleKey: "permits",
    version: "3.0.0-alpha.1",
    enabled: true,
    routes: [
      {
        path: "/permits",
        label: "Permessi",
        permission: "permits.permits.read",
        load: () => import("@ips/module-permits"),
      },
    ],
  },
  {
    moduleKey: "procedures",
    version: "3.0.0-alpha.1",
    enabled: true,
    routes: [
      {
        path: "/procedures",
        label: "Procedure",
        permission: "procedures.procedures.read",
        load: () => import("@ips/module-procedures"),
      },
    ],
  },
  {
    moduleKey: "sgs-pir",
    version: "3.0.0-alpha.1",
    enabled: true,
    routes: [
      {
        path: "/sgs-pir",
        label: "SGS/PIR",
        permission: "sgs-pir.requirements.read",
        load: () => import("@ips/module-sgs-pir"),
      },
    ],
  },
  {
    moduleKey: "tank-integrity",
    version: "3.0.0-alpha.2",
    enabled: true,
    routes: [
      {
        path: "/tank-integrity",
        label: "Serbatoi",
        permission: "tank.inspections.read",
        load: () => import("@ips/module-tank-integrity"),
      },
    ],
  },
  {
    moduleKey: "platform-admin",
    version: "3.0.0-alpha.1",
    enabled: true,
    routes: [
      {
        path: "/admin",
        label: "Impostazioni",
        permission: "platform.modules.read",
        load: () => import("@ips/admin-console"),
      },
    ],
  },
  {
    moduleKey: "rag-local",
    version: "3.0.0-alpha.1",
    enabled: true,
    routes: [
      {
        path: "/rag",
        label: "Aiuto AI",
        permission: "rag.analysis.request",
        load: () => import("@ips/module-rag-local"),
      },
    ],
  },
];
